// // src/components/ContactHero.jsx
// import React from 'react';
// import { Link } from 'react-router-dom';
// import { FaArrowRight, FaPhone, FaEnvelope, FaMapMarkerAlt } from 'react-icons/fa';

// const ContactHero = () => {
//   // Aapki contact page background image
//   const backgroundImage = "https://res.cloudinary.com/dgwnm39m7/image/upload/v1772918418/5257cb63-6d93-40a3-b177-d669d8c24045_ud0d2j.jpg";

//   return (
//     <section className="relative h-screen flex items-center justify-center overflow-hidden">
//       {/* Fixed Background Image with Parallax Effect */}
//       <div 
//         className="absolute inset-0 backgroundattachment bg-cover bg-no-repeat"
//         style={{
//           backgroundImage: `url('${backgroundImage}')`,
//           backgroundPosition:"50% 50%",
//         }}
//       >
//         {/* Dark Overlay for text readability - thoda lighter rakha hai */}
//         <div className="absolute inset-0 lg:bg-black/35 bg-black/50"></div>
        
//       </div>

//       {/* Content */}
//       <div className="container-custom relative z-10">
//         <div className="text-center text-white 2xl:space-y-8">

//           {/* Main Heading - Two lines with gold accent */}
//           <h1 className="text-5xl  md:text-7xl 2xl:text-8xl font-bold mb-4 animate-fade-in-up animation-delay-200">
//             <span className="">Get in</span>
//             <span className="font-bold text-[#c9a86c] mt-2">Touch</span>
//           </h1>

//           {/* Description */}
//           <p className="text-xl md:text-2xl 2xl:mb-10 mb-4 max-w-3xl mx-auto text-gray-200 animate-fade-in-up animation-delay-400">
//             We're here to help. Reach out to our concierge team for bookings, inquiries, or any assistance you may need.
//           </p>

//           {/* Quick Contact Info - Simple strip */}
//           <div className="flex flex-wrap justify-center gap-6 md:gap-10 2xl:mb-10 mb-4 animate-fade-in-up animation-delay-600">
//             <div className="flex items-center gap-2 text-gray-200">
//               <FaPhone className="text-[#c9a86c] text-sm" />
//               <span>+92 51 2345678</span>
//             </div>
//             <div className="flex items-center gap-2 text-gray-200">
//               <FaEnvelope className="text-[#c9a86c] text-sm" />
//               <span>info@stayin.com</span>
//             </div>
//             <div className="flex items-center gap-2 text-gray-200">
//               <FaMapMarkerAlt className="text-[#c9a86c] text-sm" />
//               <span>Centaurus, Islamabad</span>
//             </div>
//           </div>

//           {/* CTA Buttons */}
//           <div className="flex flex-col sm:flex-row gap-4 justify-center animate-fade-in-up animation-delay-800">
//             <a
//             href='#contactus'
//               className="bg-[#c9a86c]  text-white px-8 py-4 rounded-full font-medium hover:bg-[#b38f5a] transition-all duration-300 inline-flex items-center gap-2 justify-center group"
//             >
//               <span>Send Message</span>
//               <FaArrowRight className="group-hover:translate-x-1 transition-transform" />
//             </a>
//             <Link
//               to="/apartments"
//               className="bg-transparent border-2 border-white text-white px-8 py-4 rounded-full font-medium hover:bg-white hover:text-[#1a2b3c] transition-all duration-300"
//             >
//               View Apartments
//             </Link>
//           </div>
//         </div>
//       </div>
//     </section>
//   );
// };

// export default ContactHero;


// src/components/ContactHero.jsx
import React from 'react';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';
import { FaArrowRight, FaPhone, FaEnvelope, FaMapMarkerAlt } from 'react-icons/fa';

const ContactHero = () => {
  // Aapki contact page background image
  const backgroundImage = "https://res.cloudinary.com/dgwnm39m7/image/upload/v1772918418/5257cb63-6d93-40a3-b177-d669d8c24045_ud0d2j.jpg";

  // Contact information for schema
  const contactInfo = {
    phone: "+92 303 4935404",
    email: "info@stayinhospitality.com",
    address: "Centaurus Complex, Jinnah Avenue, Islamabad"
  };

  return (
    <>
      {/* SEO Meta Tags for Contact Page */}
      <Helmet>
        <title>Contact StayIN | Luxury Serviced Apartments Centaurus Islamabad</title>
        <meta name="description" content="Contact StayIN Centaurus Islamabad for luxury serviced apartment bookings. Call +92 303 4935404 , email info@stayin.com, or visit us at Centaurus Complex. Our concierge team is available 24/7." />
        <meta name="keywords" content="contact StayIN, Centaurus Islamabad phone number, StayIN email, serviced apartments contact, book luxury apartments Islamabad, StayIN Centaurus contact" />
        
        {/* Open Graph for Contact Page */}
        <meta property="og:title" content="Contact StayIN | Luxury Serviced Apartments Centaurus Islamabad" />
        <meta property="og:description" content="Contact our concierge team for bookings and inquiries. Call +92 303 4935404  or email info@stayin.com. Located at Centaurus Complex, Islamabad." />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://stayinhospitality.com/contact" />
        <meta property="og:image" content={backgroundImage} />
        <meta property="og:image:alt" content="Contact StayIN Luxury Serviced Apartments Centaurus Islamabad" />
        
        {/* Twitter Card */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Contact StayIN | Luxury Serviced Apartments Centaurus Islamabad" />
        <meta name="twitter:description" content="Contact our concierge team for bookings and inquiries. Call +92 303 4935404  or email info@stayin.com." />
      </Helmet>

      {/* Contact Page Schema Markup */}
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "ContactPage",
          "name": "Contact StayIN Centaurus",
          "description": "Contact page for StayIN luxury serviced apartments in Centaurus Islamabad",
          "url": "https://stayinhospitality.com/contact",
          "mainEntity": {
            "@type": "Organization",
            "name": "StayIN Centaurus Serviced Apartments",
            "telephone": contactInfo.phone,
            "email": contactInfo.email,
            "address": {
              "@type": "PostalAddress",
              "streetAddress": "Centaurus Complex, Jinnah Avenue",
              "addressLocality": "Islamabad",
              "addressCountry": "PK"
            },
            "contactPoint": {
              "@type": "ContactPoint",
              "telephone": contactInfo.phone,
              "contactType": "customer service",
              "availableLanguage": ["English", "Urdu"],
              "hoursAvailable": {
                "@type": "OpeningHoursSpecification",
                "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"],
                "opens": "00:00",
                "closes": "23:59"
              }
            }
          }
        })}
      </script>

      <section 
        className="relative h-screen flex items-center justify-center overflow-hidden"
        aria-label="Contact StayIN Centaurus - Luxury serviced apartments in Islamabad"
      >
        {/* Fixed Background Image with Parallax Effect */}
        <div 
          className="absolute inset-0 backgroundattachment bg-cover bg-no-repeat"
          style={{
            backgroundImage: `url('${backgroundImage}')`,
            backgroundPosition: "50% 50%",
          }}
        >
          {/* Dark Overlay for text readability - thoda lighter rakha hai */}
          <div className="absolute inset-0 lg:bg-black/35 bg-black/50"></div>
        </div>

        {/* Content */}
        <div className="container-custom relative z-10">
          <div className="text-center text-white 2xl:space-y-8">

            {/* Main Heading - Two lines with gold accent */}
            <h1 className="text-5xl md:text-7xl 2xl:text-8xl font-bold mb-4 animate-fade-in-up animation-delay-200">
              <span className="block">Get in</span>
              <span className="font-bold text-[#c9a86c] mt-2 block">Touch</span>
            </h1>

            {/* Description */}
            <p className="text-xl md:text-2xl 2xl:mb-10 mb-4 max-w-3xl mx-auto text-gray-200 animate-fade-in-up animation-delay-400">
              We're here to help. Reach out to our concierge team for bookings, inquiries, or any assistance you may need.
            </p>

            {/* Quick Contact Info - Simple strip */}
            <div className="flex flex-wrap justify-center gap-6 md:gap-10 2xl:mb-10 mb-4 animate-fade-in-up animation-delay-600">
              <div className="flex items-center gap-2 text-gray-200">
                <FaPhone className="text-[#c9a86c] text-sm" aria-hidden="true" />
                <a 
                  href="tel:+92303 4935404 " 
                  className="hover:text-[#c9a86c] transition"
                  aria-label="Call StayIN Centaurus at +92303 4935404 "
                >
                  {contactInfo.phone}
                </a>
              </div>
              <div className="flex items-center gap-2 text-gray-200">
                <FaEnvelope className="text-[#c9a86c] text-sm" aria-hidden="true" />
                <a 
                  href="mailto:info@stayinhospitality.com" 
                  className="hover:text-[#c9a86c] transition"
                  aria-label="Email StayIN Centaurus at info@stayinhospitality.com"
                >
                  {contactInfo.email}
                </a>
              </div>
              <div className="flex items-center gap-2 text-gray-200">
                <FaMapMarkerAlt className="text-[#c9a86c] text-sm" aria-hidden="true" />
                <a 
                  href="https://maps.google.com/?q=Centaurus+Islamabad"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:text-[#c9a86c] transition"
                  aria-label="View Centaurus Complex location on Google Maps"
                >
                  {contactInfo.address.split(',')[0]}
                </a>
              </div>
            </div>

            {/* CTA Buttons */}
            <div className="flex flex-col sm:flex-row gap-4 justify-center animate-fade-in-up animation-delay-800">
              <a
                href='#contactus'
                className="bg-[#c9a86c] text-white px-8 py-4 rounded-full font-medium hover:bg-[#b38f5a] transition-all duration-300 inline-flex items-center gap-2 justify-center group"
                aria-label="Send message to StayIN Centaurus"
              >
                <span>Send Message</span>
                <FaArrowRight className="group-hover:translate-x-1 transition-transform" aria-hidden="true" />
              </a>
              <Link
                to="/apartments"
                className="bg-transparent border-2 border-white text-white px-8 py-4 rounded-full font-medium hover:bg-white hover:text-[#1a2b3c] transition-all duration-300"
                aria-label="View luxury apartments in Centaurus Islamabad"
              >
                View Apartments
              </Link>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default ContactHero;